import React from 'react';
import PropTypes from 'prop-types';

// Set de ilustraciones line-art (estilo "dibujado") para decorar la tarjeta de receta, como la
// olla del ejemplo de referencia. Usan `currentColor` → toman el color de acento de la receta.
const S = { fill: 'none', stroke: 'currentColor', strokeWidth: 2.4, strokeLinecap: 'round', strokeLinejoin: 'round' };
const DOT = { fill: 'currentColor', stroke: 'none' };

export const RECIPE_ILLUSTRATIONS = [
  { key: 'pot', label: 'Olla' },
  { key: 'apple', label: 'Fruta' },
  { key: 'carrot', label: 'Vegetal' },
  { key: 'pizza', label: 'Pizza' },
  { key: 'fish', label: 'Pescado' },
  { key: 'salad', label: 'Ensalada' },
  { key: 'bread', label: 'Pan' },
  { key: 'drink', label: 'Bebida' }
];

const SHAPES = {
  pot: (
    <g {...S}>
      <path d="M27 8 q-3 -3 0 -6" />
      <path d="M37 8 q3 -3 0 -6" />
      <line x1="32" y1="11" x2="32" y2="14" />
      <path d="M18 20 Q32 12 46 20" />
      <line x1="15" y1="20" x2="49" y2="20" />
      <path d="M17 22 H47 L44.5 42 Q44 46 40 46 H24 Q20 46 19.5 42 Z" />
      <path d="M17 26 Q11 26 11 30 Q11 34 16 34" />
      <path d="M47 26 Q53 26 53 30 Q53 34 48 34" />
    </g>
  ),
  apple: (
    <g {...S}>
      <path d="M32 22 C26 16 16 18 16 30 C16 40 22 50 28 50 C30 50 31 48.5 32 48.5 C33 48.5 34 50 36 50 C42 50 48 40 48 30 C48 18 38 16 32 22 Z" />
      <path d="M32 22 C32 16 33 13 34.5 12" />
      <path d="M34 15 C39 11 45 13 45 13 C45 13 44 20.5 36 18" />
    </g>
  ),
  carrot: (
    <g {...S}>
      <path d="M26 24 L44 28 L28 50 Z" />
      <line x1="30.5" y1="31" x2="33.5" y2="30" />
      <line x1="31" y1="37" x2="34" y2="36" />
      <line x1="29.5" y1="43" x2="31.5" y2="42.5" />
      <path d="M26 24 C24 18 22 16 19 14" />
      <path d="M31 23 C31 17 31 13.5 31 11" />
      <path d="M37 25 C40 19 42 17 45 15" />
    </g>
  ),
  pizza: (
    <g {...S}>
      <path d="M32 11 L52 50 C44 54 20 54 12 50 Z" />
      <path d="M14 49 Q32 55 50 49" />
      <circle cx="32" cy="30" r="2.4" />
      <circle cx="25" cy="41" r="2.4" />
      <circle cx="39" cy="41" r="2.4" />
    </g>
  ),
  fish: (
    <g {...S}>
      <path d="M12 32 C20 20 40 20 48 32 C40 44 20 44 12 32 Z" />
      <path d="M48 32 L58 24 L58 40 Z" />
      <path d="M28 21 Q33 14 39 20.5" />
      <path d="M26 24 Q24 32 26 40" />
      <circle cx="20" cy="29" r="1.6" {...DOT} />
    </g>
  ),
  salad: (
    <g {...S}>
      <path d="M12 34 a20 16 0 0 0 40 0" />
      <line x1="10" y1="34" x2="54" y2="34" />
      <circle cx="24" cy="28" r="5" />
      <circle cx="31" cy="24" r="4" />
      <circle cx="37" cy="27" r="6" />
      <circle cx="44" cy="30" r="3" {...DOT} />
    </g>
  ),
  bread: (
    <g {...S}>
      <path d="M12 40 C12 24 52 24 52 40 Z" />
      <line x1="12" y1="40" x2="52" y2="40" />
      <line x1="22" y1="30" x2="26" y2="36" />
      <line x1="30" y1="28" x2="34" y2="34" />
      <line x1="38" y1="30" x2="42" y2="36" />
    </g>
  ),
  drink: (
    <g {...S}>
      <path d="M20 20 H44 L40 52 H24 Z" />
      <path d="M20 20 Q32 13 44 20" />
      <line x1="39" y1="12" x2="33" y2="26" />
      <line x1="23" y1="30" x2="41" y2="30" />
      <circle cx="30" cy="38" r="1.6" {...DOT} />
      <circle cx="34" cy="45" r="1.3" {...DOT} />
    </g>
  )
};

function RecipeIllustration({ name, size = 48, color = 'currentColor' }) {
  const shape = SHAPES[name];
  if (!shape) return null;
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} style={{ color, display: 'block' }} aria-hidden="true">
      {shape}
    </svg>
  );
}

RecipeIllustration.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string
};

export default RecipeIllustration;
